import { render } from "./ConfigurationRestorePointPropertiesTab.vue?vue&type=template&id=6fdc98f0&scoped=true"
import script from "./ConfigurationRestorePointPropertiesTab.vue?vue&type=script&lang=js"
export * from "./ConfigurationRestorePointPropertiesTab.vue?vue&type=script&lang=js"

import "./ConfigurationRestorePointPropertiesTab.vue?vue&type=style&index=0&id=6fdc98f0&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdc98f0"]])

export default __exports__